import { Vue, Component, Emit, Prop, Watch } from "vue-property-decorator";
import Modal from "@/assets/common/Modal/Modal.vue";
import { toCamel } from "snake-camel";
import moment from "moment";
import store from "@/assets/common/store/store";
import { File, invitationDetails } from "@/types/Component";

@Component({
    components: {
        Modal,
    },
})
export default class ProducerInvitationModal extends Vue {
    private list: any | null = null;
    private items: any = [];
    private title = "生産者の招待";
    private baseUrl = "/producer_invite";
    private withHidden = false;
    private isLoading = false;
    private headerTitle!: string;
    private isDeletable = true;
    private companyName = "";
    private tenantWorkerName = "";
    private isToggleProducerAndShippingGroup = false;
    private inviteBtnDisable = true;

    emailAddresses: string[] = [];
    emailList: string[] = Array(10).fill("");
    responseList: {
        producerName?: string;
        corporateName?: string;
        error?: string;
    }[] = Array(10).fill({});

    @Prop()
    isShowProducerInviteModal!: boolean;

    @Watch("isShowProducerInviteModal")
    private showProducerInvite() {
        this.inviteBtnDisable = true;
    }

    @Emit("inputChanged")
    inputChanged() {
        if (store.getters.isInputChanged == false) {
            this.$store.dispatch("doUpdateIsInputChanged", true);
        }
    }

    closeModal() {
        if (store.getters.isInputChanged == true) {
            const confirm = window.confirm(
                "変更内容を破棄します。よろしいですか？"
            );
            if (confirm) {
                this.$store.dispatch("doUpdateIsInputChanged", false);
                this.$emit("update:isShowProducerInviteModal", false);
                this.responseList = [];
                this.emailList = Array(10).fill("");
                this.$root.$emit('header-inert', false);
            }
        } else {
            this.$root.$emit('header-inert', false);
            this.$emit("update:isShowProducerInviteModal", false);
        }
    }

    public async onEmailBlur(index: number) {
        this.inputChanged();
        const email = this.emailList[index]?.trim();
        if (!email) {
            this.$set(this.responseList, index, {});
            this.recheckAllDuplicateErrors();
            this.updateInviteButtonState();
            return;
        }

    try {
        const res = await this.$apiClient.doRequest(
            "get",
            `${this.baseUrl}/userInviteMailInfo?mail_address=${encodeURIComponent(email)}`
        );

        const producerInfo = res.producerInfo || [];
        if (!res.producerInfo || !Array.isArray(res.producerInfo) || res.producerInfo.length === 0) {
        this.$set(this.responseList, index, {
            producerName: "",
            corporateName: "",
            error: "生産者が見つかりませんでした。",
        });
        return;
        }
        const producerNames = producerInfo.map((item: any) => item.producerName).join(", ");
        const companyNames = producerInfo.map((item: any) => item.companyName || "個人契約").join(", ");

        const isAlreadyInvited = producerInfo.some((item: any) => item.invitedAlready);
        const isAlreadyJoined = producerInfo.some((item: any) => item.alreadyJoined);

        let error = "";
        if (isAlreadyJoined) {
            error = "既に参加済みです。";
        } else if (isAlreadyInvited) {
            error = "現在、招待中です。";
        }
        this.$set(this.responseList, index, {
            producerName: producerNames,
            corporateName: companyNames,
            error,
        });

    } catch (e) {
        this.$set(this.responseList, index, {
            producerName: "",
            corporateName: "",
            error: "生産者が見つかりませんでした。",
        });
    }
    this.recheckAllDuplicateErrors();
    this.updateInviteButtonState();
    }

   private recheckAllDuplicateErrors() {
    const emailCounts: Record<string, number> = {};
    this.emailList.forEach(email => {
        const trimmed = email?.trim();
        if (trimmed) {
            emailCounts[trimmed] = (emailCounts[trimmed] || 0) + 1;
        }
    });
    this.emailList.forEach((email, i) => {
        const trimmed = email?.trim();
        const response = this.responseList[i] || {};
        const alreadyHasPriorityError =
            response.error === "既に参加済みです。" ||
            response.error === "現在、招待中です。" ||
            response.error === "生産者が見つかりませんでした。";

        if (trimmed && emailCounts[trimmed] > 1 && !alreadyHasPriorityError) {
            this.$set(this.responseList, i, {
                ...response,
                error: "同一のメールアドレスです。",
            });
        } else if (
            response.error === "同一のメールアドレスです。" &&
            (emailCounts[trimmed] ?? 0) <= 1
        ) {
            this.$set(this.responseList, i, {
                ...response,
                error: "",
            });
        }
    });
    }

    onEmailFocus() {
        this.inviteBtnDisable = true;
    }

    private updateInviteButtonState() {
        const nonEmptyEmails = this.emailList.filter(
            (email) => email && email.trim() !== ""
        );

        if (nonEmptyEmails.length === 0) {
            this.inviteBtnDisable = true;
            return;
        }

        this.inviteBtnDisable = this.responseList.some((res, idx) => {
            const email = this.emailList[idx]?.trim();
            if (!email) return false; // Skip empty emails
            return !res || !!res.error || !res.producerName;
        });
    }

    public async handleInvite() {
        const tenantId = this.$store.getters.tenantId;
        this.$emit("update:isShowProducerInviteModal", false);
        this.$store.dispatch("doUpdateIsInputChanged", false);
        this.$root.$emit('header-inert', false);
        const oneWeekLater = new Date();
        oneWeekLater.setDate(oneWeekLater.getDate() + 7);
        oneWeekLater.setHours(23, 59, 59, 0);
        function formatDate(date: Date): string {
            const pad = (n: number) => n.toString().padStart(2, '0');
            const year = date.getFullYear();
            const month = pad(date.getMonth() + 1);
            const day = pad(date.getDate());
            const hours = pad(date.getHours());
            const minutes = pad(date.getMinutes());
            const seconds = pad(date.getSeconds());
            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
          }
          const expires = formatDate(oneWeekLater);
        const params = this.emailList
            .filter((email) => !!email)
            .map((item) => {
                return {
                    mailAddress: item,
                    tenantId : this.$store.getters.tenantId,
                    expires: expires,
                };
            });
        const inviteDetailsPostForm = { invitations : params};
        this.$apiClient
            .doRequest("post", `${this.baseUrl}`, inviteDetailsPostForm)
            .then((res) => {
                this.$emit("update:isRefresh", true);
            })
            .catch((error) => {
                if (error.status === 401) {
                    this.$toasted.error(
                        "アクセストークンが不正または有効期限切れです。"
                    );
                }
                if (error.status === 400) {
                    this.$toasted.error("入力値が不足しているか不正です。");
                }
                if (error.status === 403) {
                    this.$toasted.error(
                        "リクエストの実行に必要な権限が不足しています"
                    );
                }
                if (error.status === 404) {
                    this.$toasted.error(
                        "リクエストされたリソースは存在しません。"
                    );
                }
            });
        this.responseList = [];
        this.emailList = Array(10).fill("");
    }
}
